//////////////////////////////////////////////////////////////////////
//
//  10/12/18
//  src/containers/LinkSingle.js
//
//  This file will format a single Link to navigate between windows.
//

import React from 'react';
import './LinkRow.css';

export const COCKTAIL   = "fa-cocktail";
export const BEER       = "fa-beer";
export const RESTAURANT = "fa-utensils";
export const MUSIC      = "fa-music";

//
//  To make the whole thing bigger add in 'fa-2x' in the parent element.
//  The 'circle' is filled in so you need the next element to be the inverse.
//
export const LinkSingle = ( { icolor, type, size } ) => {
  var cn_icon = "LSingleIcon fa fa-inverse fa-stack-1x " + type;
  var cn_size = "LSingleTop fa-stack " + ( ( size === "small" ) ? "fa-1x" : "fa-2x" );

  return (
  <span className={ cn_size } style={{ color : icolor }}>
    <i className="LSingleCircle fa fa-circle  fa-stack-2x"></i>
    <i className={ cn_icon }></i>
  </span>
)};




// WEBPACK FOOTER //
// ./src/components/LinkSingle.js